import { FundDocumentContextType } from '@/types/document';

/** The fixed subfolders inside every fund folder, admin and portal alike. */
export const FUND_DOCUMENT_FOLDERS = [
  {
    contextType: FundDocumentContextType.CAPITAL_CALL_NOTICE,
    name: 'Capital calls',
  },
  {
    contextType: FundDocumentContextType.DISTRIBUTION_NOTICE,
    name: 'Distributions',
  },
  {
    contextType: FundDocumentContextType.CAPITAL_ACCOUNT_STATEMENT,
    name: 'Capital accounts',
  },
];

export const GENERAL_FOLDER_NAME = 'General';

export function fundDocumentFolderName(
  contextType: FundDocumentContextType
): string {
  return (
    FUND_DOCUMENT_FOLDERS.find((folder) => folder.contextType === contextType)
      ?.name ?? contextType
  );
}
